import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const LIST_SERVICE_SYMBOL = Symbol();
const useListService = ()=>useImmutableContext(LIST_SERVICE_SYMBOL);
const useListServiceProvider = (...args)=>useImmutableContextProvider(LIST_SERVICE_SYMBOL, ...args);
export { useListService, useListServiceProvider };
